module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar additionalClasses = [];\nif(model.disabled)              additionalClasses.push('disabled');\nif(config.orientation === 'N')  additionalClasses.push('orientation_N');\nif(config.forceOneLine)         additionalClasses.push('forceOneLine');\n%>\n<div class=\"<%- additionalClasses.join(' ') %>\" data-field-code=\"<%- model.fieldCode %>\">\n<div class=\"main\">\n<div class=\"value\" title=\"<%= ((model.selectedOption || {}).realTitle || '') %>\">\n<%- (model.selectedOption || {}).realName || '&nbsp;' %>\n</div>\n<%\nif(!model.disabled){\nif(config.nullAble){\n%>\n<button class=\"unset\"><i class=\"fi fi-trash\"></i></button>\n<%\n}\n%>\n<button class=\"open\"><i class=\"fi fi-arrow-circle-down\"></i></button>\n<%\n}\n%>\n</div>\n<%\nif(!model.disabled){\n%>\n<div class=\"optionList\">\n<div class=\"filter\">\n<input type=\"text\" value=\"\" />\n<%\nif(config.addNewElementsAllowed){\n%><button class=\"add\"><i class=\"fi fi-plus-circle\"></i></button><%\n}\n%>\n</div>\n<ul>\n<%\nvar o, option;\nfor(o in model.options || []){\noption = model.options[o];\n%>\n<li data-index=\"<%= o %>\" class=\"<%= (option.selected ? 'selected' : '') %>\" title=\"<%= (option.realTitle || '') %>\">\n<%= option.realName %>\n</li>\n<%\n}\n%>\n</ul>\n</div>\n<%\n}\n%>\n</div>"
  , __filename = "node_modules/frontend-controller/baseComponents/form/fields/autoComplete.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var additionalClasses = [];
if(model.disabled)              additionalClasses.push('disabled');
if(config.orientation === 'N')  additionalClasses.push('orientation_N');
if(config.forceOneLine)         additionalClasses.push('forceOneLine');

    ; __line = 6
    ; __append("\n<div class=\"")
    ; __line = 7
    ; __append( additionalClasses.join(' ') )
    ; __append("\" data-field-code=\"")
    ; __append( model.fieldCode )
    ; __append("\">\n<div class=\"main\">\n<div class=\"value\" title=\"")
    ; __line = 9
    ; __append(escapeFn( ((model.selectedOption || {}).realTitle || '') ))
    ; __append("\">\n")
    ; __line = 10
    ; __append( (model.selectedOption || {}).realName || '&nbsp;' )
    ; __append("\n</div>\n")
    ; __line = 12
    ; 
if(!model.disabled){
if(config.nullAble){

    ; __line = 15
    ; __append("\n<button class=\"unset\"><i class=\"fi fi-trash\"></i></button>\n")
    ; __line = 17
    ; 
}

    ; __line = 19
    ; __append("\n<button class=\"open\"><i class=\"fi fi-arrow-circle-down\"></i></button>\n")
    ; __line = 21
    ; 
}

    ; __line = 23
    ; __append("\n</div>\n")
    ; __line = 25
    ; 
if(!model.disabled){

    ; __line = 27
    ; __append("\n<div class=\"optionList\">\n<div class=\"filter\">\n<input type=\"text\" value=\"\" />\n")
    ; __line = 31
    ; 
if(config.addNewElementsAllowed){

    ; __line = 33
    ; __append("<button class=\"add\"><i class=\"fi fi-plus-circle\"></i></button>")
    ; 
}

    ; __line = 35
    ; __append("\n</div>\n<ul>\n")
    ; __line = 38
    ; 
var o, option;
for(o in model.options || []){
option = model.options[o];

    ; __line = 42
    ; __append("\n<li data-index=\"")
    ; __line = 43
    ; __append(escapeFn( o ))
    ; __append("\" class=\"")
    ; __append(escapeFn( (option.selected ? 'selected' : '') ))
    ; __append("\" title=\"")
    ; __append(escapeFn( (option.realTitle || '') ))
    ; __append("\">\n")
    ; __line = 44
    ; __append(escapeFn( option.realName ))
    ; __append("\n</li>\n")
    ; __line = 46
    ; 
}

    ; __line = 48
    ; __append("\n</ul>\n</div>\n")
    ; __line = 51
    ; 
}

    ; __line = 53
    ; __append("\n</div>")
    ; __line = 54
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=node_modules/frontend-controller/baseComponents/form/fields/autoComplete.ejs

}